<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>后台管理</el-breadcrumb-item>
    <el-breadcrumb-item>三级导航栏管理</el-breadcrumb-item>
  </el-breadcrumb>
   <el-card>
<el-button type="primary" @click="showNavigation('1')">添加三级导航栏</el-button>
      <el-table
    :data="menusList"
    border
    style="width: 100%">
    <el-table-column
      prop="info_ID"
      label="ID"
      show-overflow-tooltip
      width="100">
    </el-table-column>
    <el-table-column
      prop="info_NAME"
      label="名字"
      show-overflow-tooltip
      width="130">
    </el-table-column>
    <el-table-column
      width="180"
      prop="create_DATA"
      label="创建时间">
    </el-table-column>
        <el-table-column
      width="180"
      prop="htmlPath"
      show-overflow-tooltip
      label="html状态">
    </el-table-column>
         <el-table-column
      label="操作"
      width="280">
        <template slot-scope="scope" >
<el-button  @click="deleteMenus(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
<!-- <el-button  icon="el-icon-aim" size="small" @click="showExcelByHeadId(scope.row)"></el-button> -->
<el-button v-if="scope.row.isFourMenus!=0"  @click="inserHtml(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tianjia"></use></svg></el-button>
   <el-button  @click="updateHtml(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
   </template>
    </el-table-column>
  </el-table>
   </el-card> 

   <el-dialog
  title="添加三级菜单"
  :visible.sync="dialogVisible"
  width="30%"
  center
  >
 <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
  <el-form-item label="名称" prop="info_NAME">
    <el-input  v-model="ruleForm.info_NAME" ></el-input>
  </el-form-item>
    <el-form-item label="上级菜单" prop="INFO_CLASSs_ID" label-width="140px">
  <el-select v-model="ruleForm.INFO_CLASSs_ID" placeholder="请选择上级菜单" @change="setVal(ruleForm.INFO_CLASSs_ID)">
      <el-option v-show="!info.isMenus||info.router=='InfoFour'" :label="info.info_CLASS_NAME" :value="info.info_CLASS_ID" v-for="(info,index) in InfoList" :key="index"></el-option>
    </el-select>
</el-form-item>

<el-form-item label="是否包含四级菜单" prop="isMenus" v-show="isShow" label-width="140px">
    <el-radio-group v-model="ruleForm.isFourMenus">
      <el-radio  label="0">是</el-radio>
      <el-radio  label="1">否</el-radio>
    </el-radio-group>
  </el-form-item>

 <el-form-item label="上传图片" prop="images" style="text-align: center;">
<el-upload
  action="https://jsonplaceholder.typicode.com/posts/"
  list-type="picture-card"
  :auto-upload="false"
  :limit="1"
   accept="image/png,image/gif,image/jpg,image/jpeg"
   ref="upload"
  :on-preview="handlePictureCardPreview"
  :on-remove="handleRemove"
   :on-change="changeFile2">
  <i class="el-icon-plus"></i>
</el-upload>
</el-form-item>
</el-form>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
    <el-button @click="dialogVisible = false">取 消</el-button>
  </span>
</el-dialog>
<el-dialog
  title="导航栏页面添加"
  :visible.sync="showInsertHtml"
  width="40%">

<el-row>
  <el-col :span="12"><div class="grid-content bg-purple">
<el-upload
  class="upload-demo"
  drag
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  :on-change="fileChange"
   ref="uploads"
   :limit="1"
  :on-remove="fileRemove"
  accept=".html,.htm">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将html文件拖到此处，或<em>点击上传</em></div>
</el-upload>
  </div></el-col>
  <el-col :span="12"><div class="grid-content bg-purple-light">

<el-upload
  class="upload-demo"
  drag
  ref="upload"
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  multiple="multiple"
  :show-file-list="false"
  :on-change="handleChanges"
  :on-remove="handleRemoves">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将文件样式文件拖到此处，或<em>点击上传</em></div>
   <div class="el-upload__tip" slot="tip">累计上传{{fileList5.length}}个文件</div>
</el-upload>
  </div></el-col>
</el-row>

<div class="block">
</div>
  <span slot="footer" class="dialog-footer">
     <el-button type="primary" @click="resetResult">重 置</el-button>
    <el-button @click="showInsertHtml = false">取 消</el-button>
    <el-button type="primary" @click="subInsertHtml">提 交</el-button>
  </span>
</el-dialog>



<el-dialog
  title="导航栏页面修改"
  :visible.sync="updataHtml"
  width="50%">
   <el-form ref="updateHomePageRef" :model="updateHomePageForm" :rules="updateHomePageRules" label-width="80px">
  <el-form-item label="名称" prop="info_NAME">
    <el-input v-model="updateHomePageForm.info_NAME"></el-input>
  </el-form-item>
      <el-form-item label="上级菜单" prop="INFO_CLASSs_ID">
  <el-select v-model="updateHomePageForm.INFO_CLASSs_ID">
      <el-option  v-show="!info.isMenus" :label="info.info_CLASS_NAME" :value="info.info_CLASS_ID" v-for="(info,index) in InfoList" :key="index"></el-option>
    </el-select>
</el-form-item>
<el-form-item label="是否包含四级菜单：" prop="isFourMenus" v-show="isShow"  label-width="200px">
    <el-radio-group v-model="updateHomePageForm.isFourMenus">
      <el-radio  label="0">是</el-radio>
      <el-radio  label="1">否</el-radio>
    </el-radio-group>
  </el-form-item>
<el-form-item label="当前顺序" prop="menusOrder">
    <el-input v-model="updateHomePageForm.menusOrder"></el-input>
  </el-form-item>

  <el-form-item label="图片" prop="imageUrl">
<el-upload
  class="avatar-uploader"
  action="https://jsonplaceholder.typicode.com/posts/"
  :show-file-list="false"
  :auto-upload="false"
   accept="image/png,image/gif,image/jpg,image/jpeg"
    :on-change="imageHandChange"  
    :on-remove="imageHandRemoves">
  <img v-if="imageUrl" :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>

</el-form-item>
  <el-form-item>
  </el-form-item>
</el-form>
  <!-- 底部区域 -->
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="onUpdateSubmit">立即修改</el-button>
    <el-button @click="updataHtml = false">取 消</el-button>
    <el-button  type="" @click="resetUpdate()">重置</el-button>
  </span>
  
  
  
  </el-dialog>










  </div>
</template>

<script >
export default {
    created(){
        this.getMenus()
    },
data(){
    return{
   dialogVisible:false,
   showInsertHtml:false,
   updataHtml:false,
   isShow:true,
   imageUrl:'',
   updateHtmlId:'',
    fileList5: [],
       fileList6:[],
       fileList3:[],
       fileList4:[],
   menusList:[],
    dialogImageUrl: '',
    InfoList:[],
    updateHomePageForm:{
      info_ID:'',
      menusOrder:'',
info_NAME:'',
INFO_CLASSs_ID:'',
imageUrl:'',
oldImgUrl:'',
isFourMenus:'',
    },
    updateHomePageRules:{
      info_NAME:[
          { required: true, message: '请输入名称', trigger: 'change' },
             { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
      ],
       INFO_CLASSs_ID:[
          { required: true, message: '选择二级菜单', trigger: 'change' },     
      ],
     
    },
    ruleForm:{
    info_NAME:'',
    INFO_CLASSs_ID:'',
    images:'',
    isFourMenus:'',
    },
    rules:{
      info_NAME:[
          { required: true, message: '请输入名称', trigger: 'blur' },
             { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
      ],
      INFO_CLASSs_ID:[
          { required: true, message: '请选择二级菜单名称',  trigger: 'change' },
          
      ],images:[{ required: true, message: '请上传图片',  trigger:'change' },],
    }
    }
},
methods:{
  getMenus(){
this.axios.post("/info/getMenus")
          .then(resp => { 
                      if(resp.data.status == 1) {    
                         this.menusList=resp.data.result  
                         console.log( this.menusList)                                                            
                                }else {
                                    alert("失败")
                                   this.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })},
                            deleteMenus(data){
                              const that=this
        this.$confirm("确定删除？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/info/deleteMenus","info_ID="+data.info_ID)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                        that.$message.success("删除成功")  
                        that.getMenus()                                                   
                                }else {
                                    alert("失败")
                                    that.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            }) 
      }).catch(()=>{});
     },
                            updateHtml(data){
                            this.updataHtml=true
                            this.updateHtmlId=data.info_ID
                            this.updateHomePageForm.info_ID=data.info_ID
                            this.showNavigation('2')
                     this.axios.post("/info/getMenusById?infoID="+data.info_ID)
                     .then(resp=>{
                       if(resp.data.status == 1) {   
                        console.log(resp.data.result)
                             this.imageUrl=this.$imagepath+resp.data.result[0].filePath
                             this.updateHomePageForm.oldImgUrl=this.$imagepath+resp.data.result[0].filePath
                             this.updateHomePageForm.INFO_CLASSs_ID=resp.data.result[0].info_CLASSs_ID        
                             this.updateHomePageForm.info_NAME=resp.data.result[0].info_NAME      
                             this.updateHomePageForm.menusOrder=resp.data.result[0].menusOrder   
                             this.updateHomePageForm.isFourMenus=resp.data.result[0].isFourMenus                                          
                                }else {
                                    alert("失败")
                                  //  this.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
                    


                            },
    showNavigation(data){
      if(data==1){
         this.dialogVisible=true
      }
       this.axios.post("/info/getInfoClass")
                 .then(resp => { 
                      if(resp.data.status == 1) {    
                       console.log(resp.data.result)                                           
                               this.InfoList=resp.data.result                                                         
                                }else {
                                    alert("失败")
                                   this.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
    }, setVal(data){
      for(let i=0;i<this.InfoList.length;i++){
        if(this.InfoList[i].info_CLASS_ID==data){
        if(this.InfoList[i].router=='InfoFour'&this.InfoList[i].isMenus){
          console.log(this.InfoList[i])
        this.isShow=false
        this.ruleForm.isFourMenus=1
        this.updateHomePageForm.isFourMenus==1
        }else{
          this.isShow=true
        } 
        }
      }
      console.log(data)
    },
     
    submitForm(ruleForm){
       this.$refs[ruleForm].validate(
        (valid)=>{
         if (!valid)
          return 
        let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
           this.axios.post("/info/insertMenus",this.ruleForm,config)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                        this.$message.success("添加成功")
                                   this.dialogVisible=false
                                    this.getMenus()    
                               this.$refs.upload.clearFiles()
                                }else {
                                    alert("失败")
                                   this.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
    })}, 
    onUpdateSubmit(){
        this.$refs.updateHomePageRef.validate((valid)=>{
         if (!valid)
         return
    let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
           this.axios.post("/info/updateMenusByID",this.updateHomePageForm,config)
            .then(resp => { 
                      if(resp.data.status == 1) {    
                        this.$message.success("修改成功")
                                   this.updataHtml=false
                                    this.getMenus()    
                               this.$refs.updateHomePageRef.resetFields()
                                }else {
                                    alert("失败")
                                   this.$message.error(resp.result.message)                               
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
 }
     

         
        )
    },
     handleRemove(file, fileList) {
      this.ruleForm.images=''
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
        changeFile2(file, fileList) {
        this.ruleForm.images = fileList[0].raw
          },
          inserHtml(data){
        this.insertid=data.info_ID
          this.showInsertHtml=true;
      },
            imageHandChange(file, fileList) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.updateHomePageForm.imageUrl=file.raw
      },
      imageHandRemoves(file, fileList) {
       this.updateHomePageForm.imageUrl=''
      },
      handleChanges(file, fileList) {
      this.fileList5=fileList
      },handleRemoves(file, fileList) {
        this.fileList5=fileList
      },fileChange(file, fileList){
        this.fileList3=fileList
      },fileRemove(file, fileList){
        this.fileList3=fileList
      },   resetResult(){
         this.fileList5=[]
                                  this.fileList6=[]
                                  this.fileList3=[]
                                  this.fileList4=[]
                                  this.$refs.upload.clearFiles()
                                  this.$refs.uploads.clearFiles()
      }  , 
      resetUpdate(){
    this.$refs.updateHomePageRef.resetFields()

      },
      
      subInsertHtml(){
         if(this.fileList5.length <= 0 ||this.fileList3.length==0 ){
           this.$message.error("请选择上传文件") 
         return false}



    for(var i=0;i<this.fileList5.length;i++){
     this.fileList6.push(this.fileList5[i].raw)
    }
    this.fileList4=this.fileList3[0].raw
     let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      const fd = new FormData();
       this.fileList6.forEach((file) => {
         fd.append("style", file);
      });
      fd.append("infoLClassID",this.insertid)
      fd.append("file",this.fileList4)
        this.axios.post("/info/insertHtmlMenus",fd,config)
         .then(resp => { 
                       if(resp.data.status == 1) {
                                  this.$message.success("添加成功")
                                  this.fileList5=[]
                                  this.fileList6=[]
                                  this.fileList3=[]
                                  this.fileList4=[]
                                  this.$refs.upload.clearFiles()
                                  this.$refs.uploads.clearFiles()
                                   this.showInsertHtml=false    
                                }else {
                                  this.$message.error(resp.data.message)
                                  this.fileList6=[],
                                  this.fileList4=[],
                                       alert("出错")    
                                        this.$message.error(resp.result.message)                           
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
  
      }
          
   
    }
}

</script>

<style scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/work/navigation/majorsetup/ThreeNavigation.vue